<button nbButton (click)="routeAction()">{{contentElement?.text}}</button>

